import { render } from "./KskCountdownRing.vue?vue&type=template&id=55034184&scoped=true"
import script from "./KskCountdownRing.vue?vue&type=script&lang=js"
export * from "./KskCountdownRing.vue?vue&type=script&lang=js"

import "./KskCountdownRing.vue?vue&type=style&index=0&id=55034184&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55034184"]])

export default __exports__